import { createFileRoute } from "@tanstack/react-router";

import { redirectAuthenticated } from "../router/auth";
import { RouterOutlet } from "../router/components";

export const Route = createFileRoute("/_public")({
  component: RouterOutlet,
  beforeLoad: ({ context, location, abortController }) =>
    redirectAuthenticated(
      context.auth,
      location.pathname,
      abortController.signal,
    ),
});
